import React, { FC, ReactElement } from 'react';
import { ListContextProvider, useCheckMinimumRequiredProps } from 'react-admin';
import { ListView, TitlePropType, ListProps } from 'ra-ui-materialui/lib';
import { CircularProgress, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

import useListController from './useListController';

const useStyles = makeStyles({
  progress: {
    position: 'absolute',
    top: '25%',
    left: '55%'
  }
});

const ForceListRender: FC<ListProps & {
  forceShowList?: boolean;
  children: ReactElement;
}> = ({ forceShowList = false, ...props }) => {
  useCheckMinimumRequiredProps('List', ['children'], props);
  const controllerProps = useListController(props);
  const classes = useStyles();
  if (forceShowList && controllerProps.total === 0) {
    // React-Admin 3.17.0+ ListView renders an empty page if total = 0
    controllerProps.total = 1;
  }

  return (
    <ListContextProvider value={controllerProps}>
      {controllerProps.loaded && !controllerProps.loading && (
        <ListView {...props} {...controllerProps} />
      )}
      {controllerProps.loading && (
        <div className={classes.progress}>
          <CircularProgress />
        </div>
      )}
    </ListContextProvider>
  );
};

ForceListRender.propTypes = {
  // the props you can change
  // @ts-ignore-line
  actions: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
  aside: PropTypes.element,
  // @ts-ignore-line
  bulkActionButtons: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
  children: PropTypes.element,
  classes: PropTypes.object,
  className: PropTypes.string,
  filter: PropTypes.object,
  filterDefaultValues: PropTypes.object,
  filters: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  forceShowList: PropTypes.bool,
  // @ts-ignore-line
  pagination: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
  perPage: PropTypes.number.isRequired,
  //@ts-ignore-line
  sort: PropTypes.shape({
    field: PropTypes.string,
    order: PropTypes.string
  }),
  title: TitlePropType,
  // the props managed by react-admin
  authProvider: PropTypes.func,
  hasCreate: PropTypes.bool,
  hasEdit: PropTypes.bool,
  hasList: PropTypes.bool,
  hasShow: PropTypes.bool,
  location: PropTypes.any,
  match: PropTypes.any,
  path: PropTypes.string,
  resource: PropTypes.string
};

ForceListRender.defaultProps = {
  filter: {},
  forceShowList: false,
  perPage: 10,
  hasCreate: false,
  hasEdit: false,
  hasList: true,
  hasShow: false
};

export default ForceListRender;
